module.exports = __webpack_public_path__ + "img/icon_flag.c2a2b541.svg";